import apiClient from './api';

export interface ItemMovementStatementRow {
  movementDate: string;
  movementType: string;
  referenceNumber: string;
  fromLocation: string;
  fromLocationAr: string;
  toLocation: string;
  toLocationAr: string;
  quantityIn: number;
  quantityOut: number;
  balance: number;
  unitCost: number;
  value: number;
  notes: string;
}

export interface ItemMovementStatementResult {
  itemId: number;
  itemCode: string;
  itemName: string;
  itemNameAr: string;
  branchId: number | null;
  branchName: string | null;
  branchNameAr: string | null;
  openingBalance: number;
  openingValue: number;
  totalIn: number;
  totalInValue: number;
  totalAvailable: number;
  totalAvailableValue: number;
  physicalCount: number;
  physicalCountValue: number;
  consumption: number;
  consumptionValue: number;
  fromDate: string;
  toDate: string;
  movements: ItemMovementStatementRow[];
}

export const itemMovementStatementsService = {
  getStatement: async (params: {
    itemId: number;
    fromDate: string;
    toDate: string;
    branchId?: number;
    warehouseId?: number;
    movementType?: string;
  }): Promise<ItemMovementStatementResult> => {
    const query = new URLSearchParams({
      itemId: params.itemId.toString(),
      fromDate: params.fromDate,
      toDate: params.toDate,
    });
    if (params.branchId) query.append('branchId', params.branchId.toString());
    if (params.warehouseId) query.append('warehouseId', params.warehouseId.toString());
    if (params.movementType && params.movementType !== 'all')
      query.append('movementType', params.movementType);

    const response = await apiClient.get(`/ItemMovementStatements?${query.toString()}`);
    return response.data;
  },
};
